import React, { useContext } from "react";
import { useParams } from "react-router-dom";
import { Context } from "../Context/Context";
import IndividualProductPage from "../Components/IndividualProductPage/IndividualProductPage";

const Product = () => {
  const { all_products } = useContext(Context);
  const { productName } = useParams();

  const product = all_products?.find(
    (e)=> e.name === productName
  );

  if (!product) {
    return <div>loading product...</div>;
  }

  return (
    <div>
      <IndividualProductPage product={ product } />
    </div>
  )
};

export default Product;
